function TokenService($resource, AppConstants, $cookieStore) {
	'ngInject';

	return $resource(`${AppConstants.apiUrl}/refresh-token`, {}, {
		refresh: {
			method: 'POST',
			params: {
				token: $cookieStore.get('token')
			}
		}
	});
}

export default TokenService;



/** WEBPACK FOOTER **
 ** ./client/components/token/token.service.js
 **/